var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortlisted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 30c0 16.569-13.431 30-30 30-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30 16.569 0 30 13.431 30 30Z",
    fill: "#8125DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.674 26.97c.16-.51.428-.955.966-1.104.42-.116.867-.14 1.305-.18 2.266-.208 4.533-.41 6.801-.61.183-.015.279-.085.351-.259.993-2.332 1.998-4.658 2.992-6.99.202-.473.506-.823 1.011-.967.74-.21 1.457.145 1.778.888.679 1.57 1.35 3.143 2.024 4.715.339.79.683 1.578 1.013 2.372.064.153.145.223.31.237a1240.404 1240.404 0 0 1 7.74.7c.637.06 1.08.396 1.281.995.209.623.03 1.169-.464 1.6a1734.946 1734.946 0 0 1-5.747 5.014c-.173.151-.24.277-.184.519.575 2.467 1.135 4.938 1.7 7.408.146.646-.004 1.204-.55 1.6-.544.394-1.123.375-1.695.034-2.185-1.302-4.37-2.6-6.55-3.908-.186-.112-.318-.114-.506-.003-2.171 1.303-4.349 2.598-6.526 3.892-.739.439-1.533.325-2.012-.285-.303-.386-.379-.823-.271-1.295.563-2.47 1.124-4.94 1.7-7.409.058-.251.01-.396-.186-.566-1.91-1.652-3.806-3.318-5.712-4.974-.282-.245-.445-.55-.571-.887.002-.18.002-.359.002-.538Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortlisted);
export default __webpack_public_path__ + "static/media/shortlisted.c65722d568a1ff903c28ed2869bd215f.svg";
export { ForwardRef as ReactComponent };